import TicketList from '../components/tickets/TicketList';

export default function TicketsPage() {
  return <TicketList />;
} 